import React from 'react';

/**
 * Stat — single KPI card used at the top of Admin. Pure presentational.
 * Extracted from Admin.jsx.
 */
const AdminStat = ({ icon: Icon, label, value, sub, accent }) => (
  <div className={`bg-enf-surface-deep border ${accent ? 'border-enf-accent-fg/40' : 'border-enf-surface-border'} rounded-xl p-5`}>
    <div className="flex items-center justify-between mb-3">
      <div className={`w-9 h-9 rounded-md ${accent ? 'bg-enf-accent/15' : 'bg-enf-surface-mid'} flex items-center justify-center`}>
        <Icon className={`w-4 h-4 ${accent ? 'text-enf-accent-fg' : 'text-enf-role-info'}`} />
      </div>
      {sub && <span className="text-xs text-enf-text-muted">{sub}</span>}
    </div>
    <div className="font-display text-4xl tracking-wide leading-none">{value}</div>
    <div className="text-xs text-enf-text-muted uppercase tracking-wider mt-2">{label}</div>
  </div>
);

export default AdminStat;
